<div class="homeowner-photo-viewer-container"
     data-testid="homeowner-photo-viewer-container">
  @if (isLoading) {
  <p-message severity="info"
             class="loading-message"
             data-testid="homeowner-photo-viewer-loading">
    Loading homeowner photo...
  </p-message>
  } @else if (downloadReady) {
  <p-message severity="success"
             class="success-message"
             data-testid="homeowner-photo-viewer-success">
    Homeowner photo is ready for download.
  </p-message>
  } @else if (errorMessage) {
  <p-message [severity]="errorSeverity"
             class="error-message"
             data-testid="homeowner-photo-viewer-error">
    {{ errorMessage }}
  </p-message>
  }
</div>
